import { CSSProperties, useEffect } from 'react';
import { Collapse } from '@mantine/core';
import { useDisclosure, useScrollIntoView } from '@mantine/hooks';

import { useScrollTopOffset } from '../layout/LayoutContext';

import { WidgetHeader } from './WidgetHeader';

import styles from './widget.module.scss';

export type WidgetAction = {
  title: string;
  icon: { name: string; solid?: boolean; svgIcon?: boolean };
  label?: string;
  cb?: () => void | Promise<void>;
  disabled?: boolean;
  // opens a menu and shows more actions as menu items
  moreActions?: WidgetMoreAction[];
};

export type WidgetMoreAction = {
  icon?: { name: string; solid?: boolean; svgIcon?: boolean };
  label: string;
  tooltip?: string;
  cb?: () => void | Promise<void>;
  disabled?: boolean;
};

export type WidgetProps = {
  actions?: WidgetAction[];
  children?: React.ReactNode;
  collapsible?: boolean;
  dataTestId?: string;
  enableScrollElementToTop?: boolean;
  style?: CSSProperties;
  contentStyle?: CSSProperties;
  title: string;
};

export function Widget({
  children,
  dataTestId,
  style,
  contentStyle,
  ...widgetHeaderProps
}: WidgetProps) {
  const [opened, { toggle }] = useDisclosure(true);

  return (
    <div
      className={`widget-root ${styles['root']}`}
      data-testid={dataTestId}
      style={style}
    >
      <WidgetHeader
        {...widgetHeaderProps}
        toggleContent={toggle}
        opened={opened}
      />
      {children && (
        <Collapse
          className={styles['collapse']}
          in={opened}
          style={contentStyle}
        >
          {children}
        </Collapse>
      )}
    </div>
  );
}
